module.exports = __webpack_public_path__ + "static/media/zoomin.80f55b80.svg";